import * as React from 'react';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import StepContent from '@mui/material/StepContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import LaunchIcon from '@mui/icons-material/Launch';
import Alert from '@mui/material/Alert';
import './VerticalStepper.css';

export default function VerticalStepper({onStepComplete, onStepBack, steps, stepsCompleted}) {

  const [activeStep, setActiveStep] = React.useState(0);

  React.useEffect(()=>{
    console.log(`inside stepper: ${stepsCompleted}`);
    if (stepsCompleted !== activeStep) {
      setActiveStep(stepsCompleted);
    }
  }, [stepsCompleted]);

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    onStepComplete(); // Call the callback function
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
    onStepBack();
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  return (
    <Box sx={{ maxWidth: 400, margin: 'auto' }}>
      <Stepper activeStep={activeStep} orientation="vertical">
        {steps.map((step, index) => (
          <Step key={step.label}
          sx={{
            '& .MuiStepLabel-root .Mui-completed': {
              color: '#720ac2', // circle color (COMPLETED)
            },
            '& .MuiStepLabel-root .Mui-active': {
              color: '#720ac2', // circle color (ACTIVE)
            },
          }}>
            <StepLabel>
              <h4 className='step-label'>
              {step.label}
              </h4>
            </StepLabel>
            <StepContent>
              <Typography><h5 className='step-desc'>{step.description}</h5></Typography>
              <Box sx={{ mt: 1, mb: 2, display: 'flex', alignItems: 'center' }}>
                <a href={step.link} target='_blank' rel="noreferrer"><LaunchIcon sx={{ m: '15px', color: '#9924f1', ':hover': {color: '#8119d1'} }} /></a>
                <Button
                  variant="contained"
                  onClick={handleNext}
                  sx={{ mr: 1 , bgcolor: '#9924f1', ':hover': {bgcolor: '#8119d1'}}}
                >
                  {index === steps.length - 1 ? 'Finish' : 'Done'}
                </Button>
                <Button
                  disabled={index === 0}
                  onClick={handleBack}
                  sx={{ mr: 1 , color: '#9924f1'}}
                >
                  Back
                </Button>
              </Box>
            </StepContent>
          </Step>
        ))}
      </Stepper>
      {activeStep === steps.length && (
        <Box sx={{mt: 2, mb: 2}}>
          <Alert severity='success' sx={{backgroundColor: '#b794eb9e'}}>All steps completed - you&apos;re finished!</Alert>
          <Button
            variant="contained"
            onClick={handleBack}
            sx={{ m: 2, bgcolor: '#9924f1', ':hover': {bgcolor: '#8119d1' }}}
          >
            Back
          </Button>
        </Box>
      )}
    </Box>
  );
}
